import { Component, Input } from '@angular/core';

@Component({
  selector: 'ag-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.css']
})
export class PageTitleComponent {

  @Input()
  pageTitle: string;
}
